import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Toaster, toast } from "sonner";
import {
  ArrowRight,
  Car,
  Check,
  Mail,
  MapPin,
  Menu,
  Mountain,
  Phone,
  Shield,
  Sparkles,
  Star,
  X,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const CONTACT_PHONE_DISPLAY = "(425) 683-6042";
const CONTACT_PHONE_HREF = "tel:+14256836042";
const CONTACT_EMAIL = "timberline.detailing.wa@gmail.com";
const encodeMailtoBody = (data) =>
  encodeURIComponent(
    `New detail request\n\nName: ${data.name}\nEmail: ${data.email}\nPhone: ${data.phone}\nService: ${data.service}\nMessage: ${data.message}`
  );

const images = {
  logo:
    "https://customer-assets.emergentagent.com/job_detail-showcase-10/artifacts/fpsnrijr_ChatGPT%20Image%20May%2031%2C%202026%2C%2001_43_38%20PM.png",
  hero:
    "https://static.prod-images.emergentagent.com/jobs/fbfb0e8c-790c-4480-93c4-a0919d94bab6/images/2ce464cf1ddf8302e116f360152c84b4efb875dbecc7859f49da7d2a570feadf.png",
  ceramic:
    "https://static.prod-images.emergentagent.com/jobs/fbfb0e8c-790c-4480-93c4-a0919d94bab6/images/e8d44b6338478f99a175511244113c1acae7a99a01c5badfe42ea5d5f31f9ba3.png",
  beforeAfter:
    "https://static.prod-images.emergentagent.com/jobs/fbfb0e8c-790c-4480-93c4-a0919d94bab6/images/0df6efb4f65b72f0e4c0aa934c282ac636a36ad0c69997dcbe1649dba372b51b.png",
  texture:
    "https://static.prod-images.emergentagent.com/jobs/fbfb0e8c-790c-4480-93c4-a0919d94bab6/images/6cbfa83a20df21cc97717071112ac1ddad4397d01147e4136767f6ea9d18a003.png",
  polish:
    "https://images.pexels.com/photos/14231684/pexels-photo-14231684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior:
    "https://images.unsplash.com/photo-1691157415383-9e85455a0f9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMGxlYXRoZXIlMjBjYXIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODAyNTg3NjJ8MA&ixlib=rb-4.1.0&q=85",
  mountain:
    "https://images.pexels.com/photos/19758141/pexels-photo-19758141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  beforeDirty:
    "https://images.unsplash.com/photo-1770935883781-a2f5a52b69da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxkaXJ0eSUyMG11ZGR5JTIwY2FyJTIwYmVmb3JlJTIwd2FzaHxlbnwwfHx8fDE3ODAyNjEzOTh8MA&ixlib=rb-4.1.0&q=85",
  beforeDirtyWhite:
    "https://images.unsplash.com/photo-1774978238849-fe6bda95c27d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxkaXJ0eSUyMG11ZGR5JTIwY2FyJTIwYmVmb3JlJTIwd2FzaHxlbnwwfHx8fDE3ODAyNjEzOTh8MA&ixlib=rb-4.1.0&q=85",
  exteriorFoam:
    "https://images.pexels.com/photos/29504457/pexels-photo-29504457.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  exteriorPolish:
    "https://images.pexels.com/photos/6870296/pexels-photo-6870296.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  exteriorClean:
    "https://images.unsplash.com/photo-1550652346-ba6056bab346?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBjYXIlMjBkZXRhaWxpbmclMjBleHRlcmlvcnxlbnwwfHx8Ymx1ZXwxNzgwMjYxMzk4fDA&ixlib=rb-4.1.0&q=85",
  interiorCockpit:
    "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGNhciUyMGludGVyaW9yJTIwZGV0YWlsaW5nfGVufDB8fHxibGFja3wxNzgwMjYxMzk4fDA&ixlib=rb-4.1.0&q=85",
  interiorWheel:
    "https://images.unsplash.com/photo-1612895889627-f293a1b742c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMGNhciUyMGludGVyaW9yJTIwZGV0YWlsaW5nfGVufDB8fHxibGFja3wxNzgwMjYxMzk4fDA&ixlib=rb-4.1.0&q=85",
  interiorCleaning:
    "https://images.pexels.com/photos/6873015/pexels-photo-6873015.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  sliderBefore:
    "https://static.prod-images.emergentagent.com/jobs/fbfb0e8c-790c-4480-93c4-a0919d94bab6/images/09a538fc9f19d388c38da91f13e516ba75464f6497b1ba488ca857f4a573a8f1.png",
  sliderAfter:
    "https://static.prod-images.emergentagent.com/jobs/fbfb0e8c-790c-4480-93c4-a0919d94bab6/images/4ab08c7542349c4c864878b4cbbc76d24bdc267b597f320be2a659c8fe6f2ff4.png",
};

const navItems = [
  { label: "Home", page: "home", testId: "nav-home-link" },
  { label: "Services", page: "services", testId: "nav-services-link" },
  { label: "Pricing", page: "pricing", testId: "nav-pricing-link" },
  { label: "Work", page: "work", testId: "nav-work-link" },
  { label: "Reviews", page: "reviews", testId: "nav-reviews-link" },
  { label: "Contact", page: "contact", testId: "nav-contact-link" },
];

const pagePaths = {
  home: "/",
  services: "/services",
  pricing: "/pricing",
  work: "/work",
  reviews: "/reviews",
  contact: "/contact",
};

const pathPages = Object.entries(pagePaths).reduce((acc, [page, path]) => {
  acc[path] = page;
  return acc;
}, {});

const getPageFromPath = () => {
  const path = window.location.pathname.replace(/\/$/, "") || "/";
  return pathPages[path] || "home";
};

const services = [
  {
    title: "Exterior",
    eyebrow: "Foam / wheels / gloss",
    text: "Paint-safe hand wash, trail-grime removal, wheel detail, glass, trim, and a sharp gloss finish.",
    icon: Sparkles,
    number: "01",
    testId: "service-exterior-card",
  },
  {
    title: "Interior",
    eyebrow: "Steam / reset / protect",
    text: "Vacuum, steam, vents, cupholders, leather conditioning, glass, and high-touch cabin surfaces.",
    icon: Car,
    number: "02",
    testId: "service-interior-card",
  },
  {
    title: "Ceramic",
    eyebrow: "Beading / depth / shield",
    text: "Hydrophobic protection, deeper reflections, easier maintenance, and a glassy blacktop-style finish.",
    icon: Shield,
    number: "03",
    testId: "service-ceramic-card",
  },
  {
    title: "Full Detail",
    eyebrow: "Inside / outside / complete",
    text: "A full reset for daily drivers, trucks, SUVs, adventure rigs, and vehicles that work hard.",
    icon: Mountain,
    number: "04",
    testId: "service-full-detail-card",
  },
];

const reviews = [
  {
    name: "Jake T.",
    vehicle: "Toyota Tacoma",
    service: "Full Detail",
    text: "Took my muddy Tacoma in after a weekend in the mountains. It looked better than the day I bought it.",
  },
  {
    name: "Megan R.",
    vehicle: "Subaru Outback",
    service: "Deep Interior Clean",
    text: "The interior detail was unbelievable. Dog hair, coffee stains, winter salt — all gone. Super professional.",
  },
  {
    name: "Chris W.",
    vehicle: "Ford Bronco",
    service: "Ceramic Protection",
    text: "The ceramic coating made the paint look deep and slick. Rain just rolls off now. Worth every penny.",
  },
  {
    name: "Avery S.",
    vehicle: "Honda CR-V",
    service: "Interior + Exterior Basic",
    text: "Fast, clean, and easy to book. The car had road grime everywhere and came back looking crisp inside and out.",
  },
  {
    name: "Noah P.",
    vehicle: "Ram 1500",
    service: "Exterior Deep Clean",
    text: "Wheels, tires, jambs, and bugs were handled. It made the truck look ready to sell even though I’m keeping it.",
  },
  {
    name: "Taylor M.",
    vehicle: "Jeep Wrangler",
    service: "Add-on Pet Hair",
    text: "The pet hair removal was worth it. I honestly didn’t think the back seat could look normal again.",
  },
];

const workPhotos = [
  { title: "Foam Wash Reset", category: "Exterior", image: images.exteriorFoam, testId: "work-photo-exterior-foam" },
  { title: "Paint Polish Pass", category: "Exterior", image: images.exteriorPolish, testId: "work-photo-exterior-polish" },
  { title: "Clean Front Finish", category: "Exterior", image: images.exteriorClean, testId: "work-photo-exterior-clean" },
  { title: "Cockpit Refresh", category: "Interior", image: images.interiorCockpit, testId: "work-photo-interior-cockpit" },
  { title: "Wheel + Dash Detail", category: "Interior", image: images.interiorWheel, testId: "work-photo-interior-wheel" },
  { title: "Interior Wipe-Down", category: "Interior", image: images.interiorCleaning, testId: "work-photo-interior-cleaning" },
];

const pricingPackages = [
  {
    name: "Full Detail",
    price: "$130–$170",
    tag: "Most advertised",
    category: "Best seller",
    description: "Full interior + exterior detail without wax or polish.",
    includes: ["Exterior Deep Clean", "Interior Deep Clean", "Wheels + tires fully cleaned", "Full interior refresh"],
    featured: true,
  },
  {
    name: "Interior + Exterior Basic",
    price: "$95–$120",
    tag: "Best seller",
    category: "Combo",
    description: "A strong entry bundle for a clean reset inside and out.",
    includes: ["Basic exterior wash", "Basic interior clean", "Vacuum + wipe-down", "Wheels and tires cleaned"],
  },
  {
    name: "Basic Exterior Wash",
    price: "$35–$50",
    tag: "Maintenance",
    category: "Exterior",
    description: "Good for quick clean maintenance.",
    includes: ["Hand soap wash", "Wheel + tire scrub", "Basic drying", "Optional light tire shine"],
  },
  {
    name: "Exterior Deep Clean",
    price: "$60–$85",
    tag: "Main exterior seller",
    category: "Exterior",
    description: "A deeper exterior reset for bug, tar, wheels, jambs, and trim.",
    includes: ["Foam/soap hand wash", "Light bug + tar removal", "Wheels, tires, wheel wells scrubbed", "Door jamb wipe-down", "Tire shine", "Basic trim wipe"],
  },
  {
    name: "Basic Interior Clean",
    price: "$60–$80",
    tag: "Interior refresh",
    category: "Interior",
    description: "Simple interior cleanup for vehicles that need a fresh reset.",
    includes: ["Full vacuum", "Dash + console wipe-down", "Door panels cleaned", "Light stain spot treatment", "Trash removal"],
  },
  {
    name: "Deep Interior Clean",
    price: "$90–$130",
    tag: "Deep cabin reset",
    category: "Interior",
    description: "A thorough interior clean for dirt, stains, crevices, and odors.",
    includes: ["Full vacuum + crevice cleaning", "Carpet agitation + scrub", "Seat cleaning", "Stain treatment", "Dashboard + console deep wipe", "Door panels detailed", "Interior glass", "Light odor neutralizer"],
  },
];

const addOns = [
  "Pet hair removal +$15–$40",
  "Extra stain removal +$10–$30",
  "Heavy trash cleanout +$10–$25",
  "Extra dirty interior fee +$15–$50",
  "Bug/tar heavy removal +$10–$25",
  "Engine bay light clean +$25–$50",
  "Wheel deep scrub upgrade +$10–$20",
  "Mobile fee +$10–$30",
  "Same-day booking +$15",
];

const detailStages = [
  { label: "Inspect", text: "Quick condition scan and package match." },
  { label: "Decon", text: "Lift dirt, grime, bugs, brake dust, and embedded buildup." },
  { label: "Reset", text: "Interior/exterior detail work based on the selected package." },
  { label: "Protect", text: "Finish with tire dressing, glass clarity, and clean handoff." },
];

const initialForm = {
  name: "",
  email: "",
  phone: "",
  service: "Full Detail",
  message: "",
};

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState(getPageFromPath);
  const [beforeAfterPosition, setBeforeAfterPosition] = useState(50);
  const [workFilter, setWorkFilter] = useState("All");
  const [activeStage, setActiveStage] = useState(0);
  const [formData, setFormData] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const goToPage = (page) => {
    setActivePage(page);
    setMenuOpen(false);
    const nextPath = pagePaths[page] || "/";
    if (window.location.pathname !== nextPath) {
      window.history.pushState({ page }, "", nextPath);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handlePopState = () => {
      setActivePage(getPageFromPath());
      setMenuOpen(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.history.replaceState({ page: getPageFromPath() }, "", window.location.pathname);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
    const titles = {
      home: "Seattle Car Detailing | Timberline Auto Detail",
      services: "Services | Timberline Auto Detail Seattle",
      pricing: "Pricing | Timberline Auto Detail Seattle",
      work: "Work Gallery | Timberline Auto Detail Seattle",
      reviews: "Reviews | Timberline Auto Detail Seattle",
      contact: "Contact | Timberline Auto Detail Seattle",
    };
    document.title = titles[activePage] || titles.home;
  }, [activePage]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData, { timeout: 12000 });
      toast.success("Request sent — Timberline will follow up soon.");
      setFormData(initialForm);
    } catch (error) {
      const subject = encodeURIComponent("Timberline Auto Detail Request");
      const body = encodeMailtoBody(formData);
      toast.error("Online booking had trouble sending. Please tap Email Request below or call/text us.");
      window.setTimeout(() => {
        const fallback = document.querySelector('[data-testid="contact-email-fallback-link"]');
        if (fallback) fallback.focus();
      }, 50);
      const fallbackLink = document.querySelector('[data-testid="contact-email-fallback-link"]');
      if (fallbackLink) {
        fallbackLink.setAttribute("href", `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderPage = () => {
    if (activePage === "services") {
      return (
        <section className="page-shell relative px-5 pb-20 pt-32 sm:px-8 lg:px-12" data-testid="services-section">
          <div className="mx-auto max-w-[1520px]">
            <PageIntro eyebrow="Services" title="Pick your reset." description="Four direct service paths. No clutter, no endless scrolling — choose what fits your vehicle and request a detail." testId="services" />
            <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-testid="services-grid">
              {services.map((service, index) => {
                const Icon = service.icon;
                return (
                  <article key={service.title} className="service-blade group relative min-h-[340px] overflow-hidden border border-white/10 bg-white/[0.03] p-6 transition duration-500 hover:-translate-y-2 hover:border-[#0087ff]/70" style={{ animationDelay: `${index * 90}ms` }} data-testid={service.testId}>
                    <span className="absolute right-5 top-4 font-heading text-6xl font-black italic tracking-[-0.04em] text-white/[0.045] transition duration-500 group-hover:text-[#0087ff]/20" data-testid={`${service.testId}-number`}>{service.number}</span>
                    <div className="mb-10 grid h-14 w-14 place-items-center rounded-2xl border border-[#0087ff]/35 bg-[#0087ff]/10 text-[#42a5ff]" data-testid={`${service.testId}-icon`}>
                      <Icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <p className="text-xs font-black uppercase tracking-[0.24em] text-[#42a5ff]" data-testid={`${service.testId}-eyebrow`}>{service.eyebrow}</p>
                    <h3 className="mt-4 font-heading text-4xl font-extrabold uppercase leading-tight tracking-wide text-slate-100" data-testid={`${service.testId}-title`}>{service.title}</h3>
                    <p className="mt-6 text-sm leading-7 text-slate-300" data-testid={`${service.testId}-description`}>{service.text}</p>
                  </article>
                );
              })}
            </div>
          </div>
        </section>
      );
    }

    if (activePage === "pricing") {
      return (
        <section className="page-shell relative px-5 pb-20 pt-32 sm:px-8 lg:px-12" data-testid="pricing-section">
          <div className="mx-auto max-w-[1520px]">
            <PageIntro eyebrow="Pricing" title="Full detail starts at $130." description="Same price range for all vehicle types. Final price depends on vehicle condition, severity, and selected add-ons." testId="pricing" />
            <div className="grid gap-5 lg:grid-cols-3" data-testid="pricing-grid">
              {pricingPackages.map((pkg) => (
                <article key={pkg.name} className={`pricing-card relative overflow-hidden rounded-[1.7rem] border p-6 ${pkg.featured ? "border-[#0087ff]/70 bg-[#0087ff]/10 shadow-[0_0_70px_rgba(0,135,255,0.18)]" : "border-white/10 bg-white/[0.035]"}`} data-testid={`pricing-card-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>
                  <div className="mb-5 flex items-center justify-between gap-4">
                    <span className="rounded-full border border-white/10 bg-black/50 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#42a5ff]" data-testid={`pricing-category-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>{pkg.category}</span>
                    <span className="text-xs font-black uppercase tracking-[0.18em] text-slate-400" data-testid={`pricing-tag-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>{pkg.tag}</span>
                  </div>
                  <h3 className="font-heading text-4xl font-extrabold uppercase leading-tight tracking-wide text-slate-100" data-testid={`pricing-title-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>{pkg.name}</h3>
                  <p className="mt-4 text-4xl font-black text-white" data-testid={`pricing-price-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>{pkg.price}</p>
                  <p className="mt-4 text-sm leading-7 text-slate-300" data-testid={`pricing-description-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>{pkg.description}</p>
                  <ul className="mt-6 grid gap-3" data-testid={`pricing-includes-${pkg.name.toLowerCase().replaceAll(" ", "-")}`}>
                    {pkg.includes.map((item) => (
                      <li key={item} className="flex gap-3 text-sm text-slate-200">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#42a5ff]" aria-hidden="true" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <button type="button" onClick={() => goToPage("contact")} className="mt-7 inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#0087ff] px-6 py-4 text-xs font-black uppercase tracking-[0.18em] text-white transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-black" data-testid={`pricing-book-${pkg.name.toLowerCase().replaceAll(" ", "-")}-button`}>
                    Request this package <ArrowRight className="h-4 w-4" aria-hidden="true" />
                  </button>
                </article>
              ))}
            </div>
            <div className="mt-8 rounded-[1.7rem] border border-white/10 bg-black/60 p-6" data-testid="pricing-addons-card">
              <h3 className="font-heading text-3xl font-black uppercase italic tracking-[-0.02em] text-slate-100" data-testid="pricing-addons-heading">Add-ons</h3>
              <div className="mt-5 flex flex-wrap gap-3" data-testid="pricing-addons-list">
                {addOns.map((addon) => (
                  <span key={addon} className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-sm text-slate-200" data-testid={`addon-${addon.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{addon}</span>
                ))}
              </div>
              <p className="mt-5 text-sm text-slate-400" data-testid="pricing-condition-note">Note: Final price depends on vehicle condition, extra dirt, stains, pet hair, and service location.</p>
            </div>
          </div>
        </section>
      );
    }

    if (activePage === "work") {
      const visibleWorkPhotos = workFilter === "All" ? workPhotos : workPhotos.filter((photo) => photo.category === workFilter);

      return (
        <section className="page-shell relative overflow-hidden px-5 pb-20 pt-32 sm:px-8 lg:px-12" data-testid="work-section">
          <div className="mx-auto max-w-[1520px]">
            <div className="grid gap-12 lg:grid-cols-[0.74fr_1.26fr] lg:items-center">
              <div className="relative z-10" data-testid="work-copy-block">
                <PageIntro eyebrow="Work Gallery" title="A real reset should look obvious." description="Slide between a genuinely dirty exterior and a clean finish, then browse exterior and interior detail work below." testId="work" />
                <div className="mt-10 flex flex-wrap gap-3" data-testid="work-process-list">
                {["Decontaminate", "Correct", "Protect"].map((step) => (
                  <span key={step} className="rounded-full border border-white/10 bg-white/[0.04] px-5 py-3 text-xs font-black uppercase tracking-[0.2em] text-slate-200" data-testid={`work-step-${step.toLowerCase()}`}>
                    {step}
                  </span>
                ))}
                </div>
              </div>

              <div className="split-frame relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#05070c] p-3 shadow-[0_0_70px_rgba(0,135,255,0.16)]" data-testid="before-after-showcase-card">
                <div className="relative aspect-[16/10] overflow-hidden rounded-[1.45rem]" data-testid="interactive-before-after-slider">
                  <img src={images.sliderBefore} alt="Dirty black SUV before detailing" className="absolute inset-0 h-full w-full object-cover object-center" data-testid="before-after-before-image" />
                  <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 0 0 ${beforeAfterPosition}%)` }} data-testid="before-after-after-clip">
                    <img src={images.sliderAfter} alt="Clean black SUV after detailing" className="h-full w-full object-cover object-center" data-testid="before-after-after-image" />
                  </div>
                  <div className="absolute top-0 bottom-0 w-[3px] -translate-x-1/2 bg-[#0087ff] shadow-[0_0_35px_rgba(0,135,255,1)]" style={{ left: `${beforeAfterPosition}%` }} data-testid="split-line-indicator" />
                  <div className="absolute left-6 top-6 rounded-full border border-white/10 bg-black/70 px-4 py-2 text-xs font-black uppercase tracking-[0.2em] text-slate-200 backdrop-blur" data-testid="before-label">Before</div>
                  <div className="absolute bottom-6 right-6 rounded-full bg-[#0087ff] px-4 py-2 text-xs font-black uppercase tracking-[0.2em] text-white shadow-[0_0_35px_rgba(0,135,255,0.55)]" data-testid="after-label">After</div>
                </div>
                <input type="range" min="10" max="90" value={beforeAfterPosition} onChange={(event) => setBeforeAfterPosition(Number(event.target.value))} className="detail-slider mt-5 w-full" aria-label="Before and after slider" data-testid="before-after-range-slider" />
                <p className="mt-3 text-center text-xs font-bold uppercase tracking-[0.2em] text-slate-400" data-testid="before-after-slider-instruction">Dirty to finished. Drag to compare the reset.</p>
              </div>
            </div>

            <div className="mt-16 grid gap-5 lg:grid-cols-4" data-testid="detail-stage-automation">
              {detailStages.map((stage, index) => (
                <button key={stage.label} type="button" onClick={() => setActiveStage(index)} className={`stage-card rounded-[1.4rem] border p-5 text-left transition duration-300 hover:-translate-y-1 ${activeStage === index ? "border-[#0087ff] bg-[#0087ff]/12" : "border-white/10 bg-white/[0.035]"}`} data-testid={`detail-stage-${stage.label.toLowerCase()}-button`}>
                  <span className="text-xs font-black uppercase tracking-[0.24em] text-[#42a5ff]" data-testid={`detail-stage-${stage.label.toLowerCase()}-number`}>0{index + 1}</span>
                  <h3 className="mt-4 text-xl font-black uppercase text-white" data-testid={`detail-stage-${stage.label.toLowerCase()}-title`}>{stage.label}</h3>
                  <p className="mt-2 text-sm leading-6 text-slate-400" data-testid={`detail-stage-${stage.label.toLowerCase()}-text`}>{stage.text}</p>
                </button>
              ))}
            </div>

            <div className="mt-16" data-testid="work-gallery-section">
              <div className="mb-6 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
                <h3 className="font-heading text-3xl font-extrabold uppercase tracking-wide text-slate-100" data-testid="work-gallery-heading">Exterior + Interior Work</h3>
                <div className="flex flex-wrap gap-2" data-testid="work-gallery-filter-buttons">
                  {["All", "Exterior", "Interior"].map((filter) => (
                    <button key={filter} type="button" onClick={() => setWorkFilter(filter)} className={`rounded-full border px-5 py-3 text-xs font-black uppercase tracking-[0.18em] transition duration-300 ${workFilter === filter ? "border-[#0087ff] bg-[#0087ff] text-white" : "border-white/10 bg-white/[0.04] text-slate-300 hover:border-[#0087ff] hover:text-white"}`} data-testid={`work-filter-${filter.toLowerCase()}-button`}>
                      {filter}
                    </button>
                  ))}
                </div>
              </div>
              <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3" data-testid="work-photo-grid">
                {visibleWorkPhotos.map((photo) => (
                  <article key={photo.title} className="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-white/[0.035]" data-testid={photo.testId}>
                    <img src={photo.image} alt={photo.title} className="aspect-[4/3] w-full object-cover transition duration-700 group-hover:scale-105" data-testid={`${photo.testId}-image`} />
                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black via-black/60 to-transparent p-5">
                      <p className="text-xs font-black uppercase tracking-[0.22em] text-[#42a5ff]" data-testid={`${photo.testId}-category`}>{photo.category}</p>
                      <h4 className="mt-2 text-lg font-extrabold text-white" data-testid={`${photo.testId}-title`}>{photo.title}</h4>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
      );
    }

    if (activePage === "reviews") {
      return (
        <section className="page-shell px-5 pb-20 pt-32 sm:px-8 lg:px-12" data-testid="reviews-section">
          <div className="mx-auto max-w-[1520px]">
            <div className="mb-14 flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-testid="reviews-heading-block">
              <PageIntro eyebrow="Reviews" title="Proof from the driver seat." description="More social proof, stronger layout, and quick trust signals so the reviews page feels complete." testId="reviews" />
              <div className="rounded-[1.5rem] border border-[#0087ff]/30 bg-[#0087ff]/10 p-5" data-testid="reviews-summary-card">
                <div className="flex items-center gap-2 text-[#0087ff]" data-testid="reviews-star-rating">
                  {[1, 2, 3, 4, 5].map((star) => <Star key={star} className="h-5 w-5 fill-current" aria-hidden="true" />)}
                </div>
                <p className="mt-3 text-3xl font-black text-white" data-testid="reviews-rating-text">5.0 average</p>
                <p className="text-sm text-slate-400" data-testid="reviews-summary-text">Clean cars. Fast replies. Strong first impressions.</p>
              </div>
            </div>
            <div className="mb-8 grid gap-4 md:grid-cols-3" data-testid="review-stats-grid">
              {[
                ["Fast replies", "Easy booking and package guidance"],
                ["Interior resets", "Pet hair, stains, salt, and dirt"],
                ["Exterior shine", "Wheels, bugs, grime, and gloss"],
              ].map(([title, text]) => (
                <div key={title} className="rounded-[1.3rem] border border-white/10 bg-white/[0.035] p-5" data-testid={`review-stat-${title.toLowerCase().replaceAll(" ", "-")}`}>
                  <p className="font-extrabold text-white">{title}</p>
                  <p className="mt-1 text-sm text-slate-400">{text}</p>
                </div>
              ))}
            </div>
            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3" data-testid="reviews-grid">
              {reviews.map((review, index) => (
                <article key={review.name} className="review-slab border border-white/10 bg-white/[0.035] p-8 transition duration-300 hover:-translate-y-1 hover:border-[#0087ff]/60" data-testid={`review-card-${index + 1}`}>
                  <div className="mb-6 flex gap-1 text-[#0087ff]" data-testid={`review-stars-${index + 1}`}>
                    {[1, 2, 3, 4, 5].map((star) => <Star key={star} className="h-4 w-4 fill-current" aria-hidden="true" />)}
                  </div>
                  <p className="text-base leading-8 text-slate-200" data-testid={`review-text-${index + 1}`}>“{review.text}”</p>
                  <div className="mt-7 border-t border-white/10 pt-5" data-testid={`review-author-${index + 1}`}>
                    <p className="text-lg font-black uppercase text-slate-100" data-testid={`review-name-${index + 1}`}>{review.name}</p>
                    <p className="text-sm text-slate-500" data-testid={`review-vehicle-${index + 1}`}>{review.vehicle}</p>
                    <p className="mt-2 inline-flex rounded-full bg-[#0087ff]/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-[#42a5ff]" data-testid={`review-service-${index + 1}`}>{review.service}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      );
    }

    if (activePage === "contact") {
      return <ContactPage formData={formData} handleChange={handleChange} handleSubmit={handleSubmit} isSubmitting={isSubmitting} />;
    }

    return (
      <section className="hero-scan relative min-h-screen overflow-hidden px-5 pt-24 sm:px-8 lg:px-12" data-testid="hero-section">
        <div className="pointer-events-none absolute inset-x-0 top-20 z-10 overflow-hidden border-y border-[#0087ff]/10 bg-[#0087ff]/5 py-3" data-testid="auto-scroll-proof-strip">
          <div className="marquee-track text-xs font-black uppercase tracking-[0.3em] text-[#42a5ff]/80">
            Paint-safe wash • Interior reset • Pet hair removal • Full detail starts at $130 • Ceramic-style protection • Same-day booking add-on •
          </div>
        </div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_78%_16%,rgba(0,135,255,0.24),transparent_24%),radial-gradient(circle_at_20%_80%,rgba(255,255,255,0.055),transparent_20%),linear-gradient(120deg,#020306_0%,#05070c_54%,#000_100%)]" />
        <div className="absolute left-1/2 top-28 h-[46rem] w-[46rem] -translate-x-1/2 rounded-full border border-[#0087ff]/25 opacity-60 shadow-[0_0_90px_rgba(0,135,255,0.12)]" data-testid="hero-blue-orbit" />
        <div className="relative mx-auto grid min-h-[calc(100vh-6rem)] max-w-[1520px] items-center gap-10 pb-16 lg:grid-cols-[0.95fr_1.05fr]" data-testid="hero-content">
          <div className="animate-fade-up" data-testid="hero-copy-panel">
            <p className="mb-6 inline-flex items-center gap-3 rounded-full border border-[#0087ff]/35 bg-[#0087ff]/10 px-4 py-2 text-xs font-black uppercase tracking-[0.28em] text-[#42a5ff]" data-testid="hero-overline-text">
              <Mountain className="h-4 w-4" aria-hidden="true" /> Mountain-grade auto detail
            </p>
            <h1 className="font-heading text-5xl font-extrabold uppercase leading-[1.02] tracking-wide text-slate-100 sm:text-7xl lg:text-8xl" data-testid="hero-heading">
              Not just clean. <span className="soft-word block">Dialed in.</span>
            </h1>
            <p className="mt-8 max-w-xl text-base leading-8 text-slate-300 md:text-lg" data-testid="hero-description">
              Timberline Auto Detail turns mud, salt, dust, and daily abuse into a black-glass finish with a sharp blue signature.
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row" data-testid="hero-actions">
              <button type="button" onClick={() => goToPage("pricing")} className="inline-flex items-center justify-center gap-3 rounded-full bg-[#0087ff] px-7 py-4 text-sm font-black uppercase tracking-[0.18em] text-white shadow-[0_0_30px_rgba(0,135,255,0.28)] transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-black" data-testid="hero-pricing-button">
                View pricing <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </button>
              <button type="button" onClick={() => goToPage("contact")} className="inline-flex items-center justify-center gap-3 rounded-full border border-white/20 bg-white/[0.03] px-7 py-4 text-sm font-black uppercase tracking-[0.18em] text-white transition duration-300 hover:-translate-y-1 hover:border-[#0087ff] hover:text-[#42a5ff]" data-testid="hero-book-detail-button">
                Start the reset
              </button>
            </div>
          </div>
          <div className="relative mx-auto w-full max-w-3xl animate-fade-up lg:ml-auto" style={{ animationDelay: "140ms" }} data-testid="hero-logo-stage">
            <div className="logo-monolith relative overflow-hidden rounded-[2rem] border border-white/10 bg-black/40 p-5 shadow-[0_0_65px_rgba(0,135,255,0.16)]" data-testid="hero-logo-card">
              <img src={images.logo} alt="Timberline Auto Detail mountain logo" className="aspect-square w-full object-contain" data-testid="hero-logo-image" />
            </div>
            <div className="mt-5 grid grid-cols-3 gap-3" data-testid="hero-smart-stats">
              {[["$130+", "Full detail"], ["6", "Detail packages"], ["5.0", "Review style"]].map(([value, label]) => (
                <div key={label} className="rounded-2xl border border-white/10 bg-white/[0.035] p-4 text-center backdrop-blur" data-testid={`hero-stat-${label.toLowerCase().replaceAll(" ", "-")}`}>
                  <p className="text-2xl font-black text-white">{value}</p>
                  <p className="mt-1 text-xs font-bold uppercase tracking-[0.16em] text-slate-500">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#020306] text-white selection:bg-[#0087ff] selection:text-white" data-testid="timberline-home-page">
      <Toaster richColors position="top-right" />

      <header className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-2xl" data-testid="site-header">
        <nav className="mx-auto flex max-w-[1520px] items-center justify-between px-5 py-3 sm:px-8 lg:px-12" data-testid="primary-navigation">
          <button type="button" onClick={() => goToPage("home")} className="group flex items-center gap-4" data-testid="brand-home-link">
            <img src={images.logo} alt="Timberline Auto Detail logo" className="h-14 w-20 object-contain object-left transition-transform duration-300 group-hover:scale-105 sm:w-28" data-testid="brand-logo-image" />
            <span className="hidden font-heading text-xs font-black uppercase italic tracking-[0.34em] text-white sm:block" data-testid="brand-name-text">
              Auto Detail
            </span>
          </button>

          <div className="hidden items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] p-1 md:flex" data-testid="desktop-nav-links">
            {navItems.map((item) => (
              <button key={item.page} type="button" onClick={() => goToPage(item.page)} className={`rounded-full px-4 py-3 text-xs font-black uppercase tracking-[0.16em] transition duration-300 hover:bg-[#0087ff] hover:text-white ${activePage === item.page ? "bg-[#0087ff] text-white" : "text-slate-300"}`} data-testid={item.testId}>
                {item.label}
              </button>
            ))}
          </div>

          <button type="button" onClick={() => goToPage("contact")} className="hidden items-center gap-2 rounded-full border border-[#0087ff] bg-[#0087ff] px-5 py-3 text-xs font-black uppercase tracking-[0.16em] text-white shadow-[0_0_30px_rgba(0,135,255,0.35)] transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-black md:inline-flex" data-testid="header-book-now-button">
            Book Now <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </button>

          <button className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white md:hidden" onClick={() => setMenuOpen((value) => !value)} aria-label="Toggle navigation" data-testid="mobile-menu-toggle-button">
            {menuOpen ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
          </button>
        </nav>

        {menuOpen && (
          <div className="border-t border-white/10 bg-black px-6 py-5 md:hidden" data-testid="mobile-navigation-menu">
            <div className="flex flex-col gap-4">
              {navItems.map((item) => (
                <button key={item.page} type="button" onClick={() => goToPage(item.page)} className="text-left text-sm font-bold uppercase tracking-[0.2em] text-slate-200" data-testid={`mobile-${item.testId}`}>
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </header>

      <main data-testid="active-page-container">
        {renderPage()}
      </main>

      <footer className="border-t border-white/10 bg-black px-5 py-16 sm:px-8 lg:px-12" data-testid="site-footer">
        <div className="mx-auto flex max-w-[1520px] flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <p className="font-heading text-4xl font-extrabold uppercase tracking-wide text-white sm:text-6xl" data-testid="footer-brand-text">Timberline Auto Detail</p>
            <p className="mt-4 max-w-xl text-slate-500" data-testid="footer-tagline-text">Seattle auto detailing for vehicles that climb, commute, haul, and explore.</p>
            <div className="mt-6 max-w-3xl text-sm leading-7 text-slate-500" data-testid="footer-local-seo-content">
              <p data-testid="footer-local-seo-description">
                Timberline Auto Detail serves Seattle, WA with mobile auto detailing, interior car detailing, exterior detailing, full detail packages, deep interior cleans, exterior deep cleans, and maintenance wash options.
              </p>
              <div className="mt-4 flex flex-wrap gap-2" data-testid="footer-seo-service-tags">
                {["Seattle car detailing", "Mobile auto detailing", "Interior detailing", "Exterior detailing", "Full detail", "Deep clean"].map((tag) => (
                  <span key={tag} className="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] text-slate-400" data-testid={`seo-tag-${tag.toLowerCase().replaceAll(" ", "-")}`}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <button type="button" onClick={() => goToPage("contact")} className="inline-flex items-center justify-center gap-3 rounded-full border border-[#0087ff] px-7 py-4 text-sm font-black uppercase tracking-[0.18em] text-[#42a5ff] transition duration-300 hover:-translate-y-1 hover:bg-[#0087ff] hover:text-white" data-testid="footer-book-now-button">
            Book Now <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </footer>
    </div>
  );
}

function PageIntro({ eyebrow, title, description, testId }) {
  return (
    <div className="mb-12 max-w-3xl" data-testid={`${testId}-heading-block`}>
      <p className="mb-4 text-sm font-black uppercase tracking-[0.3em] text-[#42a5ff]" data-testid={`${testId}-overline-text`}>{eyebrow}</p>
      <h2 className="font-heading text-4xl font-extrabold uppercase leading-tight tracking-wide text-slate-100 sm:text-6xl" data-testid={`${testId}-heading`}>{title}</h2>
      <p className="mt-6 max-w-2xl text-base leading-8 text-slate-300" data-testid={`${testId}-description`}>{description}</p>
    </div>
  );
}

function ContactPage({ formData, handleChange, handleSubmit, isSubmitting }) {
  return (
    <section className="page-shell bg-black px-3 pb-20 pt-28 sm:px-8 sm:pt-32 lg:px-12" data-testid="contact-section">
      <div className="contact-console mx-auto grid w-full max-w-[1520px] min-w-0 gap-5 overflow-hidden rounded-[1.35rem] border border-[#0087ff]/25 bg-[#04070d] p-3 shadow-[0_0_90px_rgba(0,135,255,0.12)] sm:rounded-[2rem] sm:p-4 lg:grid-cols-[0.8fr_1.2fr] lg:gap-8 lg:p-6">
        <div className="min-w-0 rounded-[1.15rem] border border-white/10 bg-black p-5 sm:rounded-[1.5rem] sm:p-8 lg:p-10" data-testid="contact-info-card">
          <img src={images.logo} alt="Timberline Auto Detail logo" className="mb-7 h-20 w-36 object-contain object-left sm:h-24 sm:w-44" data-testid="contact-logo-image" />
          <p className="mb-4 text-sm font-black uppercase tracking-[0.3em] text-[#42a5ff]" data-testid="contact-overline-text">Book your detail</p>
          <h2 className="font-heading text-4xl font-extrabold uppercase leading-tight tracking-wide text-slate-100 sm:text-6xl" data-testid="contact-heading">Ready for the reset?</h2>
          <p className="mt-6 text-base leading-8 text-slate-300" data-testid="contact-description">Send the vehicle, condition, and preferred timing. We’ll reply with the best package path.</p>

          <div className="mt-10 grid gap-4" data-testid="contact-button-list">
            <a href={CONTACT_PHONE_HREF} className="group flex min-w-0 items-center gap-3 rounded-2xl border border-white/10 p-4 transition duration-300 hover:-translate-y-1 hover:border-[#0087ff] hover:bg-[#0087ff]/10 sm:gap-4 sm:p-5" data-testid="contact-phone-button">
              <Phone className="h-5 w-5 shrink-0 text-[#42a5ff]" aria-hidden="true" />
              <span className="min-w-0 break-words text-sm sm:text-base" data-testid="contact-phone-text">{CONTACT_PHONE_DISPLAY}</span>
            </a>
            <a href={`mailto:${CONTACT_EMAIL}`} className="group flex min-w-0 items-center gap-3 rounded-2xl border border-white/10 p-4 transition duration-300 hover:-translate-y-1 hover:border-[#0087ff] hover:bg-[#0087ff]/10 sm:gap-4 sm:p-5" data-testid="contact-email-button">
              <Mail className="h-5 w-5 shrink-0 text-[#42a5ff]" aria-hidden="true" />
              <span className="min-w-0 break-all text-sm leading-6 sm:text-base" data-testid="contact-email-text">{CONTACT_EMAIL}</span>
            </a>
            <div className="flex min-w-0 items-start gap-3 rounded-2xl border border-white/10 p-4 text-slate-300 sm:gap-4 sm:p-5" data-testid="contact-service-area">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#42a5ff]" aria-hidden="true" />
              <span className="min-w-0 text-sm leading-6 sm:text-base" data-testid="contact-service-area-text">Serving Seattle, WA drivers, trucks, SUVs, and adventure vehicles</span>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="min-w-0 rounded-[1.15rem] border border-white/10 bg-white/[0.035] p-5 sm:rounded-[1.5rem] sm:p-8 lg:p-10" data-testid="contact-form">
          <div className="grid min-w-0 gap-5 sm:grid-cols-2">
            <label className="grid min-w-0 gap-2 text-xs font-black uppercase tracking-[0.18em] text-slate-300" data-testid="contact-name-label">
              Name
              <Input name="name" value={formData.name} onChange={handleChange} required minLength={2} placeholder="Your name" className="h-12 min-w-0 rounded-2xl border-white/10 bg-black/70 text-white placeholder:text-slate-600 focus-visible:ring-[#0087ff]" data-testid="contact-name-input" />
            </label>
            <label className="grid min-w-0 gap-2 text-xs font-black uppercase tracking-[0.18em] text-slate-300" data-testid="contact-email-label">
              Email
              <Input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="you@example.com" className="h-12 min-w-0 rounded-2xl border-white/10 bg-black/70 text-white placeholder:text-slate-600 focus-visible:ring-[#0087ff]" data-testid="contact-email-input" />
            </label>
            <label className="grid min-w-0 gap-2 text-xs font-black uppercase tracking-[0.18em] text-slate-300" data-testid="contact-phone-label">
              Phone
              <Input name="phone" value={formData.phone} onChange={handleChange} required minLength={7} placeholder="Best callback number" className="h-12 min-w-0 rounded-2xl border-white/10 bg-black/70 text-white placeholder:text-slate-600 focus-visible:ring-[#0087ff]" data-testid="contact-phone-input" />
            </label>
            <label className="grid min-w-0 gap-2 text-xs font-black uppercase tracking-[0.18em] text-slate-300" data-testid="contact-service-label">
              Service
              <select name="service" value={formData.service} onChange={handleChange} className="h-12 min-w-0 rounded-2xl border border-white/10 bg-black/70 px-3 text-white outline-none transition-colors duration-300 focus:border-[#0087ff]" data-testid="contact-service-select">
                <option>Basic Exterior Wash</option>
                <option>Exterior Deep Clean</option>
                <option>Basic Interior Clean</option>
                <option>Deep Interior Clean</option>
                <option>Interior + Exterior Basic</option>
                <option>Full Detail</option>
              </select>
            </label>
          </div>
          <label className="mt-5 grid min-w-0 gap-2 text-xs font-black uppercase tracking-[0.18em] text-slate-300" data-testid="contact-message-label">
            Vehicle / request details
            <Textarea name="message" value={formData.message} onChange={handleChange} required minLength={10} placeholder="Tell us about your vehicle, condition, and preferred timing." className="min-h-36 min-w-0 rounded-2xl border-white/10 bg-black/70 text-white placeholder:text-slate-600 focus-visible:ring-[#0087ff]" data-testid="contact-message-textarea" />
          </label>
          <Button type="submit" disabled={isSubmitting} className="mt-7 h-14 w-full rounded-full bg-[#0087ff] text-sm font-black uppercase tracking-[0.18em] text-white shadow-[0_0_45px_rgba(0,135,255,0.35)] transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-black disabled:translate-y-0 disabled:opacity-70" data-testid="contact-submit-button">
            {isSubmitting ? "Sending request..." : "Send Detail Request"}
          </Button>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-4 inline-flex h-12 w-full items-center justify-center rounded-full border border-white/10 text-sm font-black uppercase tracking-[0.16em] text-slate-300 transition duration-300 hover:border-[#0087ff] hover:text-white" data-testid="contact-email-fallback-link">
            Email Request Instead
          </a>
        </form>
      </div>
    </section>
  );
}

export default App;
